import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

const i18nConfig = {
  backend: {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
  },
  lng: "en",
  fallbackLng: "en",
  defaultNS: "translation",
  react: {
    useSuspense: false,
  },
};

export function i18nSetupLocalization(): void {
  i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init(i18nConfig)
    .catch((err) => console.error("[i18n] Failed to setup localization.", err));
}
